import { useReducer, useMemo, useState } from 'react';
import { Routes } from './Routes';
import { CssBaseline } from '@material-ui/core';
import { userReducer } from '../reducers/userReducer';
import { UserContextProvider } from '../context/UserContext';
import { CartContextProvider } from '../context/CartContext';
import { OrderContextProvider, defaultOrderContext } from '../context/OrderContext';
import { cartReducer } from '../reducers/cartReducer';
import { orderReducer } from '../reducers/orderReducer';
import { searchReducer } from '../reducers/searchReducer';
import { SearchContextProvider } from '../context/SearchContext';
import { ThemeProvider, Theme } from '@material-ui/core/styles';
import { themes } from '../app/enums';
import defaultTheme from '../themes/defaultTheme';
import manheimTheme from '../themes/manheimTheme';
import carvanaTheme from '../themes/carvanaTheme';
import { defaultUserContext } from '../models/user.interface';
import { defaultCartContext } from '../models/cart.interface';
import { defaultSearchContext } from '../models/search.interface';

export const App = () => {
  const [ state, dispatch ] = useReducer(userReducer, defaultUserContext);
  const cart = useReducer(cartReducer, defaultCartContext);
  const order = useReducer(orderReducer, defaultOrderContext);
  const search = useReducer(searchReducer, defaultSearchContext)
  const [ userTheme, setUserTheme ] = useState<string>(themes.DEFAULT);

  const theme:Theme = useMemo(
    () => {
      return userTheme === themes.MANHEIM
        ? manheimTheme 
          : userTheme === themes.CARVANA 
          ? carvanaTheme
            : defaultTheme
    },
    [userTheme],
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <UserContextProvider {...{ state, dispatch }}>
        <CartContextProvider {...cart}>
          <OrderContextProvider {...order}>
            <SearchContextProvider {...search}>
              <Routes 
                userTheme={userTheme} 
                setUserTheme={setUserTheme}
              />
            </SearchContextProvider>
          </OrderContextProvider> 
        </CartContextProvider>
      </UserContextProvider>
    </ThemeProvider>
  );
};
